export const isValidDate = (value: string | number | Date | null | undefined): value is Date => {
  if (value === undefined || value === null) {
    return false;
  }
  return !Number.isNaN(new Date(value).getTime());
};
